import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import i18next from 'i18next';

interface InformationDialogProps {
  title: string;
  children?: React.ReactNode | React.ReactNode[];
  open: boolean;
  onConfirm: () => void;
  confirmButtonText?: string;
  [x: string]: any;
}

/**
 * Information dialog for displaying informational messages to users.
 * Simple dialog with OK button for non-critical information.
 */
export default function InformationDialog(props: InformationDialogProps) {
  const { title, children, open, onConfirm, confirmButtonText, ...rest } = props;
  return (
    <Dialog open={open} onClose={() => onConfirm()} aria-labelledby="confirm-dialog" {...rest}>
      {title ? <DialogTitle id="confirm-dialog">{title}</DialogTitle> : null}
      {children ? <DialogContent>{children}</DialogContent> : null}
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm();
          }}
          color="primary"
        >
          {confirmButtonText || i18next.t('information-dialog-confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
